// import { CNav } from '@coreui/react';
import React, { useRef, useLayoutEffect, useState, useEffect } from 'react'
import { toast } from 'react-toastify';
import { submitCorporateEnrollment } from '../../../adminPanel/networkRequests/requests/subscription';
import Layout from "../../layout/default";
import { Helmet } from "react-helmet";
import { AnimWrap } from "../animation-gsap/Animation";
import { FaGlobeAmericas, FaChartLine, FaHandshake, FaRoute, FaDesktop, FaClock, FaBullseye, FaClipboardCheck } from 'react-icons/fa';
import { MdFlightTakeoff, MdPhotoCamera, MdPsychology, MdSync, MdRecordVoiceOver, MdSchool } from 'react-icons/md';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

export default function Offering() {
    const secondSection = useRef(null);
    const modelClose = useRef(null);
    const [ip, setIp] = useState([]);
    const [form, setForm] = useState({ name: '', company_name: '', email: '', phone: '', from_page: 'Corporate Page', program_name: '', b_hp_email: '' });

    const [formError, setFormError] = useState({})
    const [submitting, setSubmitting] = useState(false);
    const { executeRecaptcha } = useGoogleReCaptcha();

    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });

    useEffect(() => {
        setTimeout(() => setIp('res.data'), 100);
    }, []);

    const handleInputChange = e => {
        const { name, value } = e.target;
        setForm(prevState => ({ ...prevState, [name]: value }));
    };

    const handleOpenForm = (programName) => {
        setFormError({});
        setForm(prevState => ({ ...prevState, program_name: programName }));
    };

    const formValidate = () => {
        var re = /\S+@\S+\.\S+/;
        const phone_regex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;

        const errors = { name: false, company_name: false, phone: false, email: false };
        let isValid = true;

        if (form.name.trim() === "") {
            errors.name = true;
            isValid = false;
        }
        if (form.company_name.trim() === "") {
            errors.company_name = true;
            isValid = false;
        }
        if (form.phone.trim() === "" || !phone_regex.test(form.phone.trim())) {
            errors.phone = true;
            isValid = false;
        }
        if (form.email.trim() === "" || !re.test(form.email.trim())) {
            errors.email = true;
            isValid = false;
        }

        setFormError(errors);
        return isValid;
    }

    const onSubmiting = async () => {
        if (form.b_hp_email) return;
        if (formValidate()) {
            setSubmitting(true);

            if (!executeRecaptcha) {
                toast.error('reCAPTCHA not ready');
                setSubmitting(false);
                return;
            }

            const captchaToken = await executeRecaptcha('corporateEnrollment');

            const trimmedForm = {
                ...form,
                name: form.name.trim(),
                company_name: form.company_name.trim(),
                email: form.email.trim(),
                phone: form.phone.trim(),
                captchaToken
            };
            submitCorporateEnrollment(trimmedForm).then(res => {
                toast.success('Our team will reach you shortly');
                setForm({ name: '', company_name: '', email: '', phone: '', from_page: 'Corporate Page', program_name: '' });
                modelClose.current.click();
                setSubmitting(false);
            })
                .catch((err) => {
                    toast.error('Something went wrong!');
                    setSubmitting(false);
                });
        }
    }
    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = 100; // Offset for header overlap
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = element.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    };

    return (
        <Layout>
            <Helmet>
                <title>Shevolve | Corporate Subscription | Career Guidance Program</title>
                <meta name="description" content="Shevolve's corporate offerings are based on our patented career evaluation index and each offering is tailored to help women in different stages of their career" />
            </Helmet>

            <AnimWrap />

            {/* Modal - Kept Original */}
            <div className="modal fade bd-example-modal-lg" id="exampleModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg" role="document" style={{ top: "100px" }}>
                    <div className="modal-content">
                        <button type="button" className="close sh-modal__btn-close" data-dismiss="modal" aria-label="Close" ref={modelClose}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <div className="modal-body sh-offering__modal-body">
                            <div className="sh-title">Reach out to us !</div>
                            <input type="text" name="b_hp_email" style={{ display: 'none' }} tabIndex={-1} autoComplete="off" value={form.b_hp_email || ''} onChange={handleInputChange} />
                            <div className="row">
                                <div className="sh-offering__modal-input col-md-6 mb-4">
                                    <input className="w-100" type="text" name="name" placeholder='Your Name*' value={form.name} onChange={handleInputChange} disabled={submitting} />
                                    {formError.name === true && <span className="sh-entry__error-text mt-2">Please enter required filled</span>}
                                </div>
                                <div className="sh-offering__modal-input col-md-6 mb-4">
                                    <input className="w-100" type="text" name="company_name" id="" placeholder='Company Name*' value={form.company_name} onChange={handleInputChange} disabled={submitting} />
                                    {formError.company_name === true && <span className="sh-entry__error-text mt-2">Please enter required filled</span>}
                                </div>
                                <div className="sh-offering__modal-input col-md-6 mb-4">
                                    <input className="w-100" type="email" name="email" id="" placeholder='Work Email*' value={form.email} onChange={handleInputChange} disabled={submitting} />
                                    {formError.email === true && <span className="sh-entry__error-text mt-2">Please enter a valid email address</span>}
                                </div>
                                <div className="sh-offering__modal-input col-md-6 mb-4">
                                    <input className="w-100" type="tel" name="phone" id="" placeholder='Phone*' value={form.phone} onChange={handleInputChange} disabled={submitting} />
                                    {formError.phone === true && <span className="sh-entry__error-text mt-2">Please enter a valid Phone number</span>}
                                </div>
                            </div>
                            <div className="text-right pt-3">
                                <button className={`sh-button ${submitting ? 'sh-button--loading' : ''}`} onClick={onSubmiting} disabled={submitting}>
                                    {submitting && <span className="sh-spinner"></span>}
                                    {submitting ? 'Submitting...' : 'Submit'}
                                </button>
                            </div>
                            <div className="sh-offering__modal-image">
                                <img src="./images/offering/offering-form-butterfly.svg" alt="" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hero Section */}
            <section className="sh-section sh-offering__hero">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="mb-4 mb-lg-0">
                                <h1 className="sh-offering__hero-title sh-anim__stagger-fade-top">
                                    <strong>Developing Talent.</strong><br />
                                    Shaping Resilient<br />
                                    Workforce.
                                </h1>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="sh-offering__hero-image text-center">
                                <img src="./assets/images/corporate/hero_header.png" alt="Professional Woman" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <section className='mt-5'>
                <div className="container">
                    <div className="row mb-5 justify-content-center">
                        <div className="col-12">
                            <p className="sh-offering__hero-desc sh-offering__hero-desc--centered mx-auto">
                                Shevolve is a mentoring ecosystem designed to support professionals and organizations navigating global workforces, generational change, and evolving career journeys.
                            </p>
                        </div>
                    </div>

                    <div className="sh-offering__hero-grid">
                        <div className="sh-offering__hero-grid-item">
                            <div className="sh-offering__hero-grid-item-title"> <img src="./assets/images/corporate/icons/global.svg" alt="Global Reach" /> Global Reach</div>
                            <div className="sh-offering__hero-grid-item-desc">A diverse, trusted community of mentors bringing real-world insights and global perspective</div>
                        </div>
                        <div className="sh-offering__hero-grid-item">
                            <div className="sh-offering__hero-grid-item-title"><img src="./assets/images/corporate/icons/impact.svg" alt="Proven Impact" /> Proven Impact</div>
                            <div className="sh-offering__hero-grid-item-desc">1,000+ individuals supported in accelerating career growth, confidence, and leadership readiness.</div>
                        </div>
                        <div className="sh-offering__hero-grid-item">
                            <div className="sh-offering__hero-grid-item-title"><img src="./assets/images/corporate/icons/partnership.svg" alt="Corporate Partnership" /> Corporate Partnership</div>
                            <div className="sh-offering__hero-grid-item-desc">Partnering with global companies to develop diverse, future-ready talent</div>
                        </div>
                        <div className="sh-offering__hero-grid-item">
                            <div className="sh-offering__hero-grid-item-title"><img src="./assets/images/corporate/icons/leadership.svg" alt="Leadership Pathway" /> Leadership Pathway</div>
                            <div className="sh-offering__hero-grid-item-desc">Enabling professionals to build resilience, adaptability, and leadership capability across career stages.</div>
                        </div>
                    </div>

                    <div className="sh-offering__mission-container mt-5">
                        <h3 className="sh-offering__mission-title">Our Mission</h3>
                        <div className="sh-offering__mission-box">
                            Bridging the gap between potential and power: Empowering individuals across every generation to lead with clarity and conviction.
                            <img className="sh-offering__mission-butterfly" src="./assets/images/corporate/icons/butterfly.svg" alt="butterfly" />
                        </div>
                    </div>
                    <div className="sh-offering__mission-container mt-5">
                        <h3 className="sh-offering__mission-title">Join the Movement</h3>
                        <div className="sh-offering__mission-box">
                            At Shevolve, mentoring is more than guidance — it's a journey of transformation. Together, we're building a future where people thrive, lead, and inspire.
                            <img className="sh-offering__mission-butterfly" src="./assets/images/corporate/icons/butterfly.svg" alt="butterfly" />
                        </div>
                    </div>
                </div>
            </section>
            {/* Programs Section */}
            <section className="sh-section py-0">
                <div className="container">

                    <div className="sh-offering__table-wrapper">
                        <table className="sh-offering__table">
                            <thead>
                                <tr>
                                    <th><FaDesktop /> Program</th>
                                    <th><FaClock /> Duration</th>
                                    <th><FaBullseye /> Target Audience</th>
                                    <th><FaClipboardCheck /> Key Outcome</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr onClick={() => scrollToSection('program-flyhigh')} className="sh-offering__table-row">
                                    <td>Fly High Program</td>
                                    <td>30 Hours</td>
                                    <td>Ambitious contributors ready for strategic leadership.</td>
                                    <td>Transform from a manager into an impact-driven, visionary global leader.</td>
                                </tr>
                                <tr onClick={() => scrollToSection('program-snapshot')} className="sh-offering__table-row">
                                    <td>Snapshot Communication</td>
                                    <td>6 Hours</td>
                                    <td>Professionals across all levels needing immediate, high-impact results.</td>
                                    <td>Master "quick-win" strategies for clarity, persuasion, and professional edge</td>
                                </tr>
                                <tr onClick={() => scrollToSection('program-resilience')} className="sh-offering__table-row">
                                    <td>Resilient Mindset Lab</td>
                                    <td>10 Hours</td>
                                    <td>Professionals navigating high pressure or organizational change.</td>
                                    <td>Master the science of high performance and mental agility under stress.</td>
                                </tr>
                                <tr onClick={() => scrollToSection('program-transition')} className="sh-offering__table-row">
                                    <td>Thrive in Transition</td>
                                    <td>12 Hours</td>
                                    <td>Career returnees or those moving into new leadership roles.</td>
                                    <td>Bypass the learning curve and establish immediate leadership authority.</td>
                                </tr>
                                <tr onClick={() => scrollToSection('program-authentic')} className="sh-offering__table-row">
                                    <td>Authentic Voice Lab</td>
                                    <td>30 Hours</td>
                                    <td>Emerging leaders and managers seeking executive gravitas.</td>
                                    <td>Bridge the gap between expertise and influence with a voice that commands.</td>
                                </tr>
                                <tr onClick={() => scrollToSection('program-campus')} className="sh-offering__table-row">
                                    <td>Campus to Corporate</td>
                                    <td>10 Hours</td>
                                    <td>Graduates & Entry-level professionals (0-1 yrs).</td>
                                    <td>Transition from student to stakeholder with a "First 90 Days" roadmap.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Program: Fly High */}
                    <div className="sh-offering__program sh-anim__stagger-fade-top" id="program-flyhigh">
                        <div className="sh-offering__program-header">
                            <div className="sh-offering__program-header-title"> <img className='sh-offering__program-header-image' src="/assets/images/corporate/programs/flyhigh.svg" alt="fly-high" /></div>
                            <div className="sh-offering__program-header-subtitle">Beyond Potential. Into Power: Redefining Your Professional Trajectory</div>
                        </div>
                        <div className="sh-offering__program-desc">
                            Fly High is an immersive experience for ambitious working professionals ready to break through career plateaus. By blending strategic learning with Shevolve's signature 1:1 mentorship, we transform contributors and managers into impact-driven leaders.
                        </div>
                        <div className="sh-offering__program-section-title">Key Outcomes:</div>
                        <div className="sh-offering__program-grid">
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Explore:</div>
                                Audit your professional DNA to identify hidden strengths and growth gaps.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Emerge:</div>
                                Master the emotional intelligence and resilience required for senior roles.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Engage:</div>
                                Build high-level influence to navigate stakeholders and lead across teams.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Fly High:</div>
                                Synthesize learning into a personalized leadership roadmap for long-term career acceleration.
                            </div>
                        </div>
                        <div className="sh-offering__program-meta">
                            <span>Audience:</span> Ambitious mid-career professionals and individual contributors ready to transition into strategic leadership and people management roles.<br />
                            <span>Format:</span> <b>30 Hours</b> | Immersive | Personalized Cohorts | Real-World Simulations | 1:1 Mentorship
                        </div>
                        <div className="mt-3">
                            <button className="sh-button" data-toggle="modal" data-target="#exampleModal" onClick={() => handleOpenForm('Fly High Program')}>Enroll Now</button>
                        </div>
                    </div>

                    {/* Program: Snapshot Communication */}
                    <div className="sh-offering__program sh-anim__stagger-fade-top" id="program-snapshot">
                        <div className="sh-offering__program-header">
                            <div className="sh-offering__program-header-title"><img className='sh-offering__program-header-image' src="/assets/images/corporate/programs/communication.svg" alt="snapshot" /></div>
                            <div className="sh-offering__program-header-subtitle">Sharpen Your Professional Edge: High-Energy | Action-Oriented | Quick Wins for High Impact</div>
                        </div>
                        <div className="sh-offering__program-desc">
                            A power-packed view into impactful communication strategies. The intensive program equips working professionals with practical, high-stakes techniques to immediately enhance clarity, persuasion, and connection in any professional setting.
                        </div>
                        <div className="sh-offering__program-section-title">What You'll Master:</div>
                        <div className="sh-offering__program-grid">
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Precision Messaging:</div>
                                Techniques to deliver your point with maximum clarity and zero "fluff."
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Persuasion Tactics:</div>
                                Practical hooks to win buy-in during meetings and high-stakes conversations.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Instant Connection:</div>
                                Building rapport and professional presence in any environment, from elevators to boardrooms.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">The "Snap" Pitch:</div>
                                Mastering the art of the concise, compelling introduction that sticks.
                            </div>
                        </div>
                        <div className="sh-offering__program-meta">
                            <span>Audience:</span> Professionals across all career stages looking for an immediate boost in professional influence and communication clarity.<br />
                            <span>Format:</span> <b>6 Hours</b> | Fast-Track Intensive | Interactive Drills | Real-Time Feedback
                        </div>
                        <div className="mt-3">
                            <button className="sh-button" data-toggle="modal" data-target="#exampleModal" onClick={() => handleOpenForm('Snapshot Communication')}>Enroll Now</button>
                        </div>
                    </div>

                    {/* Program: Resilient Mindset Lab */}
                    <div className="sh-offering__program sh-anim__stagger-fade-top" id="program-resilience">
                        <div className="sh-offering__program-header">
                            <div className="sh-offering__program-header-title"><img className='sh-offering__program-header-image' src="/assets/images/corporate/programs/mindset.svg" alt="resilient" /> </div>
                            <div className="sh-offering__program-header-subtitle">Resilience as a Competitive Advantage: Master the science of high performance under pressure.</div>
                        </div>
                        <div className="sh-offering__program-desc">
                            In a world of constant change, resilience is a core professional skill. This lab equips working professionals and teams with the psychological tools to navigate ambiguity and lead through disruption without sacrificing well-being.
                        </div>
                        <div className="sh-offering__program-section-title">The Resilience Toolkit:</div>
                        <div className="sh-offering__program-grid">
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Mental Agility:</div>
                                Techniques to stay clear-headed, proactive, and decisive in high-pressure moments.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Psychological Safety:</div>
                                Master the emotional intelligence and resilience required for senior roles.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Navigating Ambiguity:</div>
                                Frameworks to lead through organizational change with composure.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Sustainable Productivity:</div>
                                Manage your energy and focus to replace burnout with long-term impact.
                            </div>
                        </div>
                        <div className="sh-offering__program-meta">
                            <span>Audience:</span> Professionals at all levels, team leads, and high-potential talent navigating high-pressure environments or organizational change.<br />
                            <span>Format:</span> <b>10 Hours</b> | Interactive Workshops | Evidence-Based Tools
                        </div>
                        <div className="mt-3">
                            <button className="sh-button" data-toggle="modal" data-target="#exampleModal" onClick={() => handleOpenForm('Resilient Mindset Lab')}>Enroll Now</button>
                        </div>
                    </div>

                    {/* Program: Thrive in Transition */}
                    <div className="sh-offering__program sh-anim__stagger-fade-top" id="program-transition">
                        <div className="sh-offering__program-header">
                            <div className="sh-offering__program-header-title"><img className='sh-offering__program-header-image' src="/assets/images/corporate/programs/transition.svg" alt="transition" /></div>
                            <div className="sh-offering__program-header-subtitle">Step In with Confidence. Step Up with Impact: Master the first 90 days of your new chapter.</div>
                        </div>
                        <div className="sh-offering__program-desc">
                            Whether you are stepping into a new role, returning to the workforce, or expanding your mandate, the start defines the finish. This program provides working professionals with a strategic roadmap to bypass the learning curve, secure early wins, and establish immediate leadership authority.
                        </div>
                        <div className="sh-offering__program-section-title">The Transition Roadmap:</div>
                        <div className="sh-offering__program-grid">
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Leadership Identity:</div>
                                Shift from "doing" to "leading" by clarifying your 100-day vision and priorities.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">High-Velocity Decisions:</div>
                                Gain tools for decisive action and team engagement under pressure.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Stakeholder Alignment:</div>
                                Map your influence and build the cross-functional alliances needed for long-term success.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Strategic Momentum:</div>
                                Execute "Quick Wins" that build credibility and accelerate your professional impact.
                            </div>
                        </div>
                        <div className="sh-offering__program-meta">
                            <span>Audience:</span> Working Professionals moving into new leadership roles, professionals taking on expanded mandates, and those re-entering the workforce after a career break<br />
                            <span>Format:</span> <b>12 Hours</b> | Strategic Coaching | Action-Oriented Frameworks
                        </div>
                        <div className="mt-3">
                            <button className="sh-button" data-toggle="modal" data-target="#exampleModal" onClick={() => handleOpenForm('Thrive in Transition')}>Enroll Now</button>
                        </div>
                    </div>

                    {/* Program: Authentic Voice Lab */}
                    <div className="sh-offering__program sh-anim__stagger-fade-top" id="program-authentic">
                        <div className="sh-offering__program-header">
                            <div className="sh-offering__program-header-title"><img className='sh-offering__program-header-image' src="/assets/images/corporate/programs/voicelab.svg" alt="authentic-voice" /> </div>
                            <div className="sh-offering__program-header-subtitle">Find Your Voice. Amplify Your Impact: Master the art of high-stakes communication.</div>
                        </div>
                        <div className="sh-offering__program-desc">
                            Leadership is about how you show up. This transformative lab helps working professionals bridge the gap between expertise and influence. We move beyond public speaking to help you lead with conviction, empathy, and a voice that commands the room.
                        </div>
                        <div className="sh-offering__program-section-title">The Core Curriculum:</div>
                        <div className="sh-offering__program-grid">
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Purpose-Driven Communication:</div>
                                Align your message with your values to resonate with global audiences.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Trust-Based Storytelling:</div>
                                Move from data-sharing to storytelling that inspires action and credibility.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Tactical Empathy:</div>
                                Navigate difficult conversations and conflict with grace and strategic precision.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Executive Presence:</div>
                                Refine your gravitas and body language to command attention and respect.
                            </div>
                        </div>
                        <div className="sh-offering__program-meta">
                            <span>Audience:</span> Emerging leaders, mid-to-senior managers, and women in technical roles looking to build executive presence and high-stakes communication skills.<br />
                            <span>Format:</span> <b>25-30 Hours</b> | Experiential Learning | Narrative Coaching
                        </div>
                        <div className="mt-3">
                            <button className="sh-button" data-toggle="modal" data-target="#exampleModal" onClick={() => handleOpenForm('Authentic Voice Lab')}>Enroll Now</button>
                        </div>
                    </div>

                    {/* Program: Campus to Corporate */}
                    <div className="sh-offering__program sh-anim__stagger-fade-top" id="program-campus">
                        <div className="sh-offering__program-header">
                            <div className="sh-offering__program-header-title"><img className='sh-offering__program-header-image' src="/assets/images/corporate/programs/campus-corporate.svg" alt="campus" /> </div>
                            <div className="sh-offering__program-header-subtitle">Your Launchpad to the Professional World: Transition with confidence. Start with impact.</div>
                        </div>
                        <div className="sh-offering__program-desc">
                            The leap from classroom to boardroom is a shift in mindset, not just environment. This dynamic program equips working professionals & individuals entering the workforce with the essential readiness to step into their first roles with clarity, purpose, and a competitive edge.
                        </div>
                        <div className="sh-offering__program-section-title">What You'll Master:</div>
                        <div className="sh-offering__program-grid">
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">The First 90 Days:</div>
                                Navigating corporate culture and professional etiquette with ease.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Strategic Communication:</div>
                                Mastering the art of the high-impact email, meeting, and pitch.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Personal Branding:</div>
                                Defining and communicating your unique value proposition from Day one.
                            </div>
                            <div className="sh-offering__program-grid-item">
                                <div className="sh-offering__program-grid-item-title">Resilience & Ownership:</div>
                                Shifting from a "student" mindset to an empowered "stakeholder."
                            </div>
                        </div>
                        <div className="sh-offering__program-meta">
                            <span>Audience:</span> Final-year students, recent graduates, and entry-level professionals (0-1 years of experience) preparing to enter the professional workforce.<br />
                            <span>Format:</span> <b>10 Hours</b> of Immersive, Fast-Track Learning
                        </div>
                        <div className="mt-3">
                            <button className="sh-button" data-toggle="modal" data-target="#exampleModal" onClick={() => handleOpenForm('Campus to Corporate')}>Enroll Now</button>
                        </div>
                    </div>

                </div>
            </section>

            {/* Partner Section */}
            <section className="sh-section sh-offering__partner">
                <div className="container">
                    <h2 className="sh-offering__partner-title">Why Global Organizations Partner with Shevolve</h2>
                    <div className="sh-offering__partner-intro">
                        <p className='mb-0'><b>Beyond Diversity. Toward Authority.</b></p>
                        <p className='mb-0'><b>We don't just fill seats; we build the table. Shevolve helps corporate partners:</b></p>
                    </div>

                    <div className="sh-offering__partner-list">
                        <div className="sh-offering__partner-item">
                            <div className="sh-offering__partner-item-title">Hire & Retain Global Talent:</div>
                            <div className="sh-offering__partner-item-desc">Cultivate an elite, inclusive culture that attracts and anchors the world's most ambitious professionals.</div>
                        </div>
                        <div className="sh-offering__partner-item">
                            <div className="sh-offering__partner-item-title">Harness Gen Z Energy:</div>
                            <div className="sh-offering__partner-item-desc">Bridge the generational divide and convert the drive of the newest workforce into a strategic asset.</div>
                        </div>
                        <div className="sh-offering__partner-item">
                            <div className="sh-offering__partner-item-title">Bridge the Leadership Gap:</div>
                            <div className="sh-offering__partner-item-desc">Architect a sustainable pipeline of "ready-now" female leaders to lead your organization forward.</div>
                        </div>
                        <div className="sh-offering__partner-item">
                            <div className="sh-offering__partner-item-title">Reclaim High-Value Talent:</div>
                            <div className="sh-offering__partner-item-desc">Seamlessly reintegrate career returnees, turning their diverse experiences into immediate professional impact.</div>
                        </div>
                        <div className="sh-offering__partner-item">
                            <div className="sh-offering__partner-item-title">Future-Proof Resilience:</div>
                            <div className="sh-offering__partner-item-desc">Equip your workforce to navigate ambiguity and lead through global disruption with clarity.</div>
                        </div>
                    </div>

                    <h2 className="sh-offering__partner-title sh-anim__stagger-fade-top mt-5">Your Evolution Starts Now.</h2>
                    <div className="sh-offering__partner-footer sh-anim__stagger-fade-top">
                        The future of leadership is diverse, resilient, and visionary. Whether you are scaling a global team or redefining your personal career path, let's build that future together.
                    </div>
                </div>
            </section>

            {/* Whatsapp CTA */}
            <section className="sh-section pb-0 pt-0">
                <div className="sh-section__inwrap">
                    <div className="container">
                        <div className="sh-whatsapp__cta-section sh-anim__stagger-fade-left" style={{ backgroundImage: "url(./images/whatsapp-cta/whatsapp-background.png)" }}>
                            <div className="row sh-whatsapp__cta-row align-items-lg-center align-items-end">
                                <div className="col-md-4 sh-whatsapp__cta-left order-2 order-md-1">
                                    <div className="text-center">
                                        <img className="img-fluid" src="./images/whatsapp-cta/whatsapp.svg" alt="" />
                                    </div>
                                </div>
                                <div className="col-md-8 sh-whatsapp__cta-right order-1 order-md-2">
                                    <div className="text-center py-5">
                                        <div className="sh-whatsapp__cta-content">
                                            <div className="sh-whatsapp__cta-title mb-1">Want to have a word with us ?</div>
                                            <div className="sh-whatsapp__cta-subtitle">Chat with us on <span className="sh-whatsapp__cta-subtitle--whatsapp">Whatsapp</span></div>
                                        </div>
                                        <a className="sh-whatsapp__cta-button--whatsapp d-inline-flex align-items-center" href="https://wa.me/919342153849" target="_blank" rel="noopener noreferrer">
                                            <img style={{ height: 30 }} src="./images/program/whatsapp.png" alt="whatsapp" />
                                            <span className="ml-2">Chat with us</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </Layout>
    )
}